<template>
  <header class="header text__center_aligment">
    <div class="header__content">
      <h1 class="text__header_1 text__accent" style="white-space: break-spaces;">
        {{ $t('home.title') }}
      </h1>
      <div class="text__subheader spacing__mt_2">
        {{ $t('home.subtitle') }}
      </div>
      <KeepMePosted class="spacing__mt_4" />
    </div>
  </header>
</template>

<script>
import KeepMePosted from './KeepMePosted'
export default {
  name: 'TheHeader',
  components: {
    KeepMePosted,
  },
}
</script>

<style lang="scss" scoped>
.header {
  background-color: white;
  width: 100%;

  &__content {
    display: flex;
    flex-flow: column;
    justify-content: center;
  }
}

@media only screen and (max-width: 768px) {
  .header h1 {
    font-size: 28px;
    line-height: 30px;
  }

  .header div {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
